module.exports = __webpack_public_path__ + "img/chanpin_2@2x.bdee7f8c.png";